import { DatesCalendarProps } from '../dates-calendar'
import {
  HouseAvailabilityGlobalStateEnum,
  TravelTypeEnum,
} from '../../../../lib/graphql'
import { ArrayElement, Nullable } from '../../../../types'

export type ComputeIsAvailabilityLockedProps = {
  houseAvailability: Nullable<
    ArrayElement<DatesCalendarProps['houseAvailabilities']>
  >
  travelType: TravelTypeEnum | null
}

export const computeHouseAvailabilityState = ({
  houseAvailability,
  travelType,
}: ComputeIsAvailabilityLockedProps): {
  isNightlyTripLocked: boolean
  isStudyDayLocked: boolean
  isCorporateEveningLocked: boolean
} => {
  let isCorporateEveningLocked = false
  let isNightlyTripLocked = false
  let isStudyDayLocked = false

  if (houseAvailability) {
    switch (houseAvailability.__typename) {
      case 'HouseAvailabilityGlobalOutputDto': {
        const { corporateEvening, nightlyTrip, studyDay } = houseAvailability

        isCorporateEveningLocked =
          travelType === TravelTypeEnum.CORPORATE_EVENING_EVENT &&
          (corporateEvening.state !== HouseAvailabilityGlobalStateEnum.FREE ||
            !corporateEvening.isEnabled)

        isNightlyTripLocked =
          travelType === TravelTypeEnum.NIGHTLY_TRIP &&
          (nightlyTrip.state !== HouseAvailabilityGlobalStateEnum.FREE ||
            !nightlyTrip.isEnabled)

        isStudyDayLocked =
          travelType === TravelTypeEnum.DAILY_TRIP &&
          (studyDay.state !== HouseAvailabilityGlobalStateEnum.FREE ||
            !studyDay.isEnabled)

        break
      }

      case 'HouseAvailabilityICalendarOutputDto': {
        isCorporateEveningLocked = true
        isNightlyTripLocked = true
        isStudyDayLocked = true

        break
      }

      case 'HouseAvailabilityIndividualOutputDto': {
        const { corporateEvening, nightlyTrip, studyDay } = houseAvailability

        isNightlyTripLocked =
          travelType === TravelTypeEnum.NIGHTLY_TRIP && !nightlyTrip.isEnabled

        isStudyDayLocked =
          travelType === TravelTypeEnum.DAILY_TRIP && !studyDay.isEnabled

        isCorporateEveningLocked =
          travelType === TravelTypeEnum.CORPORATE_EVENING_EVENT &&
          !corporateEvening.isEnabled

        break
      }
    }
  }

  return { isCorporateEveningLocked, isNightlyTripLocked, isStudyDayLocked }
}
